
export const ProductsSection = () => {
  const products = [
    {
      title: 'Marine Bio-Materials',
      description: 'Revolutionary biodegradable materials extracted from marine organisms for industrial applications and sustainable manufacturing.',
      features: ['Zero Microplastics', '100% Biodegradable', 'Industrial Grade', 'Scalable Production'],
      image: 'https://public.readdy.ai/ai/img_res/5ad526bcc56e1a34bed96732bd0b36c0.jpg'
    },
    {
      title: 'Sustainable Consumer Products',
      description: 'Eco-friendly daily use products made with marine biotechnology, combining superior performance with environmental responsibility.',
      features: ['Chemical-Free', 'Superior Performance', '100% Natural Sources', 'Fully Biodegradable'],
      image: 'https://readdy.ai/api/search-image?query=Eco-friendly%20consumer%20products%20made%20from%20marine%20biotechnology%2C%20sustainable%20daily%20use%20items%2C%20clean%20modern%20product%20photography%2C%20green%20and%20blue%20color%20scheme%2C%20environmentally%20friendly%20packaging%2C%20natural%20organic%20materials%2C%20premium%20quality%20sustainable%20products%2C%20modern%20minimalist%20design&width=600&height=400&seq=consumer-products&orientation=landscape'
    },
    {
      title: 'Research & Development Solutions',
      description: 'Cutting-edge biotechnology research services and custom solutions for pharmaceutical and industrial applications.',
      features: ['Custom R&D Services', 'Pharmaceutical Grade', 'Innovation Partnership', 'Scientific Excellence'],
      image: 'https://readdy.ai/api/search-image?query=Advanced%20biotechnology%20research%20and%20development%20laboratory%2C%20scientific%20research%20equipment%2C%20pharmaceutical%20grade%20materials%2C%20professional%20research%20environment%2C%20blue%20and%20white%20laboratory%20setting%2C%20innovation%20and%20discovery%2C%20cutting-edge%20scientific%20instruments%2C%20research%20collaboration%20workspace&width=600&height=400&seq=rd-solutions&orientation=landscape'
    }
  ];

  return (
    <section id="products" className="py-20 bg-white" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Marine Biotechnology Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover our comprehensive range of sustainable biotechnology products and services
          </p>
        </div>

        {/* Products */}
        <div className="space-y-20">
          {products.map((product, index) => (
            <div 
              key={index} 
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''
              }`}
              data-product-shop
            >
              {/* Product Image */}
              <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                <div className="relative">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="rounded-2xl shadow-2xl object-cover w-full h-80 lg:h-96"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900/10 to-transparent rounded-2xl"></div>
                </div>
              </div>

              {/* Product Info */}
              <div className={index % 2 === 1 ? 'lg:col-start-1' : ''}>
                <div className="bg-gray-50 rounded-2xl p-8">
                  <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                    {product.title}
                  </h3>
                  <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                    {product.description}
                  </p>

                  {/* Features */}
                  <div className="grid grid-cols-2 gap-3 mb-8">
                    {product.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                        <span className="text-gray-700 text-sm font-medium">{feature}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <div className="flex flex-col sm:flex-row gap-3">
                    <button className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium cursor-pointer whitespace-nowrap">
                      Learn More
                    </button>
                    <button className="border border-blue-600 text-blue-600 px-6 py-3 rounded-lg hover:bg-blue-600 hover:text-white transition-colors font-medium cursor-pointer whitespace-nowrap">
                      Contact Us
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
